<template>
  <div>
		<action-sidebar
		:title="title"
		:value="true"
		:width="widthModal"
		@close-modal="closeModal"
		>
			<v-layout px-4 mt-3 pt-3 row wrap>
				<v-flex xs12 mb-4>
					<v-text-field
						background-color="white"
						box
						class="body-1"
						hide-details
						label="Código"
						v-model="process.code"
						:disabled="notEdit"
					></v-text-field>
					<span class="form-group__message" v-if="!$v.process.code.required">
						Este campo es requerido.
					</span>
				</v-flex>
				<v-flex xs12 mb-4>
					<v-text-field
						background-color="white"
						box
						class="body-1"
						hide-details
						label="Nombre"
						v-model="process.name"
						></v-text-field>
						<span class="form-group__message" v-if="!$v.process.name.required">
							Este campo es requerido.
						</span>
				</v-flex>
				<v-flex xs12 mb-4>
					<v-text-field
						background-color="white"
						box
						class="body-1"
						hide-details
						label="Alcance"
						v-model="process.scope"
					></v-text-field>
					<span class="form-group__message" v-if="!$v.process.scope.required">
						Este campo es requerido.
					</span>
				</v-flex>
				<v-flex xs12 pb-4>
					<v-select
					background-color="white"
					class="body-1 mt-2"
					box
					hide-details
					item-text="name"
					item-value="name"
					v-model="process.module"
					:items="modules"
					label="Modulos"
					></v-select>
					<span class="form-group__message" v-if="!$v.process.module.required">
						Este campo es requerido.
					</span>
				</v-flex>
				<v-flex xs12 mb-4>
					<v-text-field
						background-color="white"
						box
						class="body-1"
						type="number"
						hide-details
						label="Orden"
						v-model="process.order"
					></v-text-field>
					<span class="form-group__message" v-if="!$v.process.order.required">
						Este campo es requerido.
					</span>
				</v-flex>
				<v-flex xs12 mb-4>
					<v-text-field
						background-color="white"
						box
						type="text"
						class="body-1"
						hide-details
						label="Descripción"
						v-model="process.description"
					></v-text-field>
				</v-flex>
				<v-flex xs12 mb-4>
					<v-layout wrap align-center>
						<v-flex xs12 sm8>
							<v-text-field
							solo
							class="body-1 mx-2 mt-0"
							height="30px"
							hide-details
							readonly
							required
							label="Imagen"
							v-model="process.urlImage"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm4 pr-0>
							<upload-image
								label-ref="up"
								label-for="image"
								input-id="image"
								@send-image="getImage"
							/>
						</v-flex>
					</v-layout>
					<span class="form-group__message" v-if="!$v.process.urlImage.required">
						Este campo es requerido.
					</span>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
				:isLoading="$v.$invalid"
				@accept-button-clicked="createProcess"
				@cancel-button-clicked="closeModal"
				></modal-sidebar-button>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import UploadImage from '@/components/shared/upload-image';
import { required } from 'vuelidate/lib/validators';

function created() {
	if (this.$route.params.id) {
		this.getProcess();
		this.notEdit = true;
	}
	this.loadModules();
}

async function loadModules() {
	try {
		const response = await this.$http.get('process-modules');
		this.modules = response.data.data;
	} catch (error) {
		this.showError();
	}
}

async function getProcess() {
	try {
		const { data: response } = await this.$http.get(`process/${this.$route.params.id}`);
		if (response.data) {
			this.process = {
				code: response.data.code,
				name: response.data.name,
				order: response.data.order,
				scope: response.data.scope,
				module: response.data.module,
				description: response.data.description,
				urlImage: response.data.urlImage,
			};
		}
	} catch (error) {
		this.showError();
	}
}

async function createProcess() {
	const body = {
		code: this.process.code,
		name: this.process.name,
		order: this.process.order,
		scope: this.process.scope,
		module: this.process.module,
		description: this.process.description,
		urlImage: this.process.urlImage,
		codeProject: this.$route.params.codeProject,
	};
	const idProcess = this.$route.params.id;
	const method = idProcess ? 'put' : 'post';
	const url = idProcess ? `process/${this.$route.params.id}` : 'process';
	const message = idProcess ? 'actualizado' : 'creado';
	try {
		await this.$http[method](url, body);
		this.showNotification(`Proceso ${message} con exito.`);
		this.closeModal();
	} catch (error) {
		if (error.status === 400) {
			this.showError('El codigo ya existe.');
		} else {
			this.showError();
		}
	}
}

function closeModal() {
	this.goTo('page-process');
}

function getImage({ urlImage }) {
	this.process.urlImage = urlImage.split();
}

function validations() {
	const validation = {
		process: {
			code: {
				required,
			},
			name: {
				required,
			},
			scope: {
				required,
			},
			module: {
				required,
			},
			urlImage: {
				required,
			},
			order: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		notEdit: false,
		modules: [],
		title: 'Nuevo Proceso',
		process: {
			code: '',
			name: '',
			scope: '',
			order: '',
			module: '',
			urlImage: null,
			description: '',
		},
		widthModal: 450,
	};
}

export default {
	name: 'page-project-create-process',
	data,
	created,
	components: {
		actionSidebar,
		UploadImage,
	},
	methods: {
		closeModal,
		createProcess,
		loadModules,
		getImage,
		getProcess,
	},
	validations,
};
</script>


// WEBPACK FOOTER //
// src/components/process/create-process.vue